import { call, put, StrictEffect, takeEvery } from "redux-saga/effects";

import { DataType } from "@/jenesys-types/data/enums";
import { extractError } from "@/jenesys-types/errors";
import { User } from "@/jenesys-types/jenesys-entities/config";

import { list } from "@/services/api";
import {
  changeClient,
  changeCompany
} from "@/store/features/companies/companies";

import {
  clearAllMembers,
  loadClientMembers,
  LoadClientMembersAction,
  loadClientMembersFailure,
  loadClientMembersSuccess,
  loadCompanyMembers,
  LoadCompanyMembersAction,
  loadCompanyMembersFailure,
  loadCompanyMembersSuccess
} from "./companyMembers";

function* loadCompanyMembersSaga(
  action: LoadCompanyMembersAction
): Generator<StrictEffect, void, any> {
  const { companyId, search } = action.payload;

  try {
    const membersData = yield call(
      list,
      DataType.Team,
      {
        limit: 50,
        offset: 0,
        ...(search && { search })
      },
      { companyId }
    );

    const members: User[] = membersData.items.map((member: any) => member.user);

    yield put(
      loadCompanyMembersSuccess(members, membersData.total, companyId, search)
    );
  } catch (error) {
    const appError = extractError(error);
    yield put(loadCompanyMembersFailure(appError, companyId));
  }
}

function* loadClientMembersSaga(
  action: LoadClientMembersAction
): Generator<StrictEffect, void, any> {
  const { clientId, search } = action.payload;

  try {
    const membersData = yield call(
      list,
      DataType.Team,
      {
        limit: 50,
        offset: 0,
        ...(search && { search })
      },
      { companyId: clientId }
    );

    const members: User[] = membersData.items.map((member: any) => member.user);

    yield put(
      loadClientMembersSuccess(members, membersData.total, clientId, search)
    );
  } catch (error) {
    const appError = extractError(error);
    yield put(loadClientMembersFailure(appError, clientId));
  }
}

function* clearMembersOnCompanyChangeSaga(
  _action: any
): Generator<StrictEffect, void, any> {
  yield put(clearAllMembers());
}

function* clearMembersOnClientChangeSaga(
  _action: any
): Generator<StrictEffect, void, any> {
  yield put(clearAllMembers());
}

export function* companyMembersSaga() {
  yield takeEvery(loadCompanyMembers.type, loadCompanyMembersSaga);
  yield takeEvery(loadClientMembers.type, loadClientMembersSaga);
  yield takeEvery(changeCompany.type, clearMembersOnCompanyChangeSaga);
  yield takeEvery(changeClient.type, clearMembersOnClientChangeSaga);
}

export default companyMembersSaga;
